import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

export default class InternalLink extends React.Component {
  createContainerProps() {
    const { to, className, ...rest } = this.props;

    return {
      to,
      className,
      activeStyle: { textDecoration: 'underline', textUnderlinePosition: 'under' },
      ...rest,
    };
  }

  render() {
    const { label, children } = this.props;

    return <Link {...this.createContainerProps()}>{children || label}</Link>;
  }
}

InternalLink.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
};

InternalLink.defaultProps = {
  label: '',
  className: '',
};
